export default __webpack_public_path__ + "static/media/Belt of the Dauntless.1d09d6ad.jpg";